import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.CollectionUpdates', null, 4);
        tmp0_serialDesc.c1b('updates', true);
        tmp0_serialDesc.c1b('remove', true);
        tmp0_serialDesc.c1b('overload', true);
        tmp0_serialDesc.c1b('condition', true);
        this.s3l_1 = tmp0_serialDesc;
      }
      t3l(typeSerial0, typeSerial1) {
        return $serializer().t3o(typeSerial0, typeSerial1);
      }
      h1c(typeParamsSerializers) {
        return this.t3l(typeParamsSerializers[0], typeParamsSerializers[1]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static u3o() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.CollectionUpdates', $this, 4);
        tmp0_serialDesc.c1b('updates', true);
        tmp0_serialDesc.c1b('remove', true);
        tmp0_serialDesc.c1b('overload', true);
        tmp0_serialDesc.c1b('condition', true);
        $this.q3o_1 = tmp0_serialDesc;
        return $this;
      }
      v3o(encoder, value) {
        var tmp0_desc = this.q3o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.w3o_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 0, new (LinkedHashSetSerializer())(this.r3o_1), value.w3o_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 1)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_0 = !equals(value.x3o_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 1, new (LinkedHashSetSerializer())(this.s3o_1), value.x3o_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.y3o_1 === false)) {
          tmp1_output.s14(tmp0_desc, 2, value.y3o_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.z3o_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, new (ConditionSerializer())(this.r3o_1), value.z3o_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.v3o(encoder, value instanceof CollectionUpdates() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q3o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, new (LinkedHashSetSerializer())(this.r3o_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, new (LinkedHashSetSerializer())(this.s3o_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.n13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, new (ConditionSerializer())(this.r3o_1), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, new (LinkedHashSetSerializer())(this.r3o_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, new (LinkedHashSetSerializer())(this.s3o_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.n13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, new (ConditionSerializer())(this.r3o_1), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return CollectionUpdates().a3p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.q3o_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (LinkedHashSetSerializer())(this.r3o_1), new (LinkedHashSetSerializer())(this.s3o_1), BooleanSerializer_getInstance(), get_nullable(new (ConditionSerializer())(this.r3o_1))];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.r3o_1, this.s3o_1];
      }
      static t3o(typeSerial0, typeSerial1) {
        var $this = this.u3o();
        $this.r3o_1 = typeSerial0;
        $this.s3o_1 = typeSerial1;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var CollectionUpdatesClass;
function CollectionUpdates() {
  if (CollectionUpdatesClass === VOID) {
    class $ {
      constructor(updates, remove, overload, condition) {
        Companion_getInstance();
        var tmp;
        if (updates === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = updates;
        }
        updates = tmp;
        var tmp_0;
        if (remove === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = remove;
        }
        remove = tmp_0;
        overload = overload === VOID ? false : overload;
        condition = condition === VOID ? null : condition;
        this.w3o_1 = updates;
        this.x3o_1 = remove;
        this.y3o_1 = overload;
        this.z3o_1 = condition;
      }
      toString() {
        return 'CollectionUpdates(updates=' + toString(this.w3o_1) + ', remove=' + toString(this.x3o_1) + ', overload=' + this.y3o_1 + ', condition=' + toString_0(this.z3o_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.w3o_1);
        result = imul(result, 31) + hashCode(this.x3o_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.y3o_1) | 0;
        result = imul(result, 31) + (this.z3o_1 == null ? 0 : this.z3o_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CollectionUpdates()))
          return false;
        if (!equals(this.w3o_1, other.w3o_1))
          return false;
        if (!equals(this.x3o_1, other.x3o_1))
          return false;
        if (!(this.y3o_1 === other.y3o_1))
          return false;
        if (!equals(this.z3o_1, other.z3o_1))
          return false;
        return true;
      }
      static a3p(seen0, updates, remove, overload, condition, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().s3l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.w3o_1 = emptySet();
        } else
          $this.w3o_1 = updates;
        if (0 === (seen0 & 2)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.x3o_1 = emptySet();
        } else
          $this.x3o_1 = remove;
        if (0 === (seen0 & 4))
          $this.y3o_1 = false;
        else
          $this.y3o_1 = overload;
        if (0 === (seen0 & 8))
          $this.z3o_1 = null;
        else
          $this.z3o_1 = condition;
        return $this;
      }
    }
    initMetadataForClass($, 'CollectionUpdates', CollectionUpdates, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    CollectionUpdatesClass = $;
  }
  return CollectionUpdatesClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance8oiu9odho220,
};
//endregion

//# sourceMappingURL=CollectionUpdates.mjs.map
